import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
:root {
  &, &.light {
  --neutral: #fff;
  /* Slate */
  --slate-50: #f8fafc;
  --slate-100: #f1f5f9;
  --slate-200: #e2e8f0;
  --slate-300: #cbd5e1;
  --slate-400: #94a3b8;
  --slate-500: #64748b;
  --slate-600: #475569;
  --slate-700: #334155;
  --slate-800: #1e293b;
  --slate-900: #0f172a;
  --slate-950: #020617;

  /* Gray */
  --gray-50: #f9fafb;
  --gray-100: #f3f4f6;
  --gray-200: #e5e7eb;
  --gray-300: #d1d5db;
  --gray-400: #9ca3af;
  --gray-500: #6b7280;
  --gray-600: #4b5563;
  --gray-700: #374151;
  --gray-800: #1f2937;
  --gray-900: #111827;
  --gray-950: #030712;

  /* Zinc */
  --zinc-50: #fafafa;
  --zinc-100: #f4f4f5;
  --zinc-200: #e4e4e7;
  --zinc-300: #d4d4d8;
  --zinc-400: #a1a1aa;
  --zinc-500: #71717a;
  --zinc-600: #52525b;
  --zinc-700: #3f3f46;
  --zinc-800: #27272a;
  --zinc-900: #18181b;
  --zinc-950: #09090b;

  /* Neutral */
  --neutral-50: #fafafa;
  --neutral-100: #f5f5f5;
  --neutral-200: #e5e5e5;
  --neutral-300: #d4d4d4;
  --neutral-400: #a3a3a3;
  --neutral-500: #737373;
  --neutral-600: #525252;
  --neutral-700: #404040;
  --neutral-800: #262626;
  --neutral-900: #171717;
  --neutral-950: #0a0a0a;

  /* Stone */
  --stone-50: #fafaf9;
  --stone-100: #f5f5f4;
  --stone-200: #e7e5e4;
  --stone-300: #d6d3d1;
  --stone-400: #a8a29e;
  --stone-500: #78716c;
  --stone-600: #57534e;
  --stone-700: #44403c;
  --stone-800: #292524;
  --stone-900: #1c1917;
  --stone-950: #0c0a09;

  /* Red */
  --red-50: #fef2f2;
  --red-100: #fee2e2;
  --red-200: #fecaca;
  --red-300: #fca5a5;
  --red-400: #f87171;
  --red-500: #ef4444;
  --red-600: #dc2626;
  --red-700: #b91c1c;
  --red-800: #991b1b;
  --red-900: #7f1d1d;
  --red-950: #450a0a;

  /* Orange */
  --orange-50: #fff7ed;
  --orange-100: #ffedd5;
  --orange-200: #fed7aa;
  --orange-300: #fdba74;
  --orange-400: #fb923c;
  --orange-500: #f97316;
  --orange-600: #ea580c;
  --orange-700: #c2410c;
  --orange-800: #9a3412;
  --orange-900: #7c2d12;
  --orange-950: #431407;

  /* Amber */
  --amber-50: #fffbeb;
  --amber-100: #fef3c7;
  --amber-200: #fde68a;
  --amber-300: #fcd34d;
  --amber-400: #fbbf24;
  --amber-500: #f59e0b;
  --amber-600: #d97706;
  --amber-700: #b45309;
  --amber-800: #92400e;
  --amber-900: #78350f;
  --amber-950: #451a03;

  /* Yellow */
  --yellow-50: #fefce8;
  --yellow-100: #fef9c3;
  --yellow-200: #fef08a;
  --yellow-300: #fde047;
  --yellow-400: #facc15;
  --yellow-500: #eab308;
  --yellow-600: #ca8a04;
  --yellow-700: #a16207;
  --yellow-800: #854d0e;
  --yellow-900: #713f12;
  --yellow-950: #422006;

  /* Lime */
  --lime-50: #f7fee7;
  --lime-100: #ecfccb;
  --lime-200: #d9f99d;
  --lime-300: #bef264;
  --lime-400: #a3e635;
  --lime-500: #84cc16;
  --lime-600: #65a30d;
  --lime-700: #4d7c0f;
  --lime-800: #3f6212;
  --lime-900: #365314;
  --lime-950: #1a2e05;

  /* Green */
  --green-50: #f0fdf4;
  --green-100: #dcfce7;
  --green-200: #bbf7d0;
  --green-300: #86efac;
  --green-400: #4ade80;
  --green-500: #22c55e;
  --green-600: #16a34a;
  --green-700: #15803d;
  --green-800: #166534;
  --green-900: #14532d;
  --green-950: #052e16;

  /* Emerald */
  --emerald-50: #ecfdf5;
  --emerald-100: #d1fae5;
  --emerald-200: #a7f3d0;
  --emerald-300: #6ee7b7;
  --emerald-400: #34d399;
  --emerald-500: #10b981;
  --emerald-600: #059669;
  --emerald-700: #047857;
  --emerald-800: #065f46;
  --emerald-900: #064e3b;
  --emerald-950: #022c22;

  /* Teal */
  --teal-50: #f0fdfa;
  --teal-100: #ccfbf1;
  --teal-200: #99f6e4;
  --teal-300: #5eead4;
  --teal-400: #2dd4bf;
  --teal-500: #14b8a6;
  --teal-600: #0d9488;
  --teal-700: #0f766e;
  --teal-800: #115e59;
  --teal-900: #134e4a;
  --teal-950: #042f2e;

  /* Cyan */
  --cyan-50: #ecfeff;
  --cyan-100: #cffafe;
  --cyan-200: #a5f3fc;
  --cyan-300: #67e8f9;
  --cyan-400: #22d3ee;
  --cyan-500: #06b6d4;
  --cyan-600: #0891b2;
  --cyan-700: #0e7490;
  --cyan-800: #155e75;
  --cyan-900: #164e63;
  --cyan-950: #083344;

  --sky-50: #f0f9ff;
  --sky-100: #e0f2fe;
  --sky-200: #bae6fd;
  --sky-300: #7dd3fc;
  --sky-400: #38bdf8;
  --sky-500: #0ea5e9;
  --sky-600: #0284c7;
  --sky-700: #0369a1;
  --sky-800: #075985;
  --sky-900: #0c4a6e;
  --sky-950: #082f49;

  /* Blue */
  --blue-50: #eff6ff;
  --blue-100: #dbeafe;
  --blue-200: #bfdbfe;
  --blue-300: #93c5fd;
  --blue-400: #60a5fa;
  --blue-500: #3b82f6;
  --blue-600: #2563eb;
  --blue-700: #1d4ed8;
  --blue-800: #1e40af;
  --blue-900: #1e3a8a;
  --blue-950: #172554;

  /* Indigo */
  --indigo-50: #eef2ff;
  --indigo-100: #e0e7ff;
  --indigo-200: #c7d2fe;
  --indigo-300: #a5b4fc;
  --indigo-400: #818cf8;
  --indigo-500: #6366f1;
  --indigo-600: #4f46e5;
  --indigo-700: #4338ca;
  --indigo-800: #3730a3;
  --indigo-900: #312e81;
  --indigo-950: #1e1b4b;

  /* Violet */
  --violet-50: #f5f3ff;
  --violet-100: #ede9fe;
  --violet-200: #ddd6fe;
  --violet-300: #c4b5fd;
  --violet-400: #a78bfa;
  --violet-500: #8b5cf6;
  --violet-600: #7c3aed;
  --violet-700: #6d28d9;
  --violet-800: #5b21b6;
  --violet-900: #4c1d95;
  --violet-950: #2e1065;

  /* Purple */
  --purple-50: #faf5ff;
  --purple-100: #f3e8ff;
  --purple-200: #e9d5ff;
  --purple-300: #d8b4fe;
  --purple-400: #c084fc;
  --purple-500: #a855f7;
  --purple-600: #9333ea;
  --purple-700: #7e22ce;
  --purple-800: #6b21a8;
  --purple-900: #581c87;
  --purple-950: #3b0764;

  /* Fuchsia */
  --fuchsia-50: #fdf4ff;
  --fuchsia-100: #fae8ff;
  --fuchsia-200: #f5d0fe;
  --fuchsia-300: #f0abfc;
  --fuchsia-400: #e879f9;
  --fuchsia-500: #d946ef;
  --fuchsia-600: #c026d3;
  --fuchsia-700: #a21caf;
  --fuchsia-800: #86198f;
  --fuchsia-900: #701a75;
  --fuchsia-950: #4a044e;

  --backdrop-color: rgba(255, 255, 255, 0.1);

  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.04);
  --shadow-md: 0px 0.6rem 2.4rem rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 2.4rem 3.2rem rgba(0, 0, 0, 0.12);
  --shadow-sm-bottm: 0 1px 2px -2px rgba(0, 0, 0, 0.04);
  --shadow-md-bottom: 0px 0.6rem 2.4rem -2.4rem rgba(0, 0, 0, 0.06);
  --shadow-lg-bottom: 0 2.4rem 3.2rem -3.2rem rgba(0, 0, 0, 0.12);

    --image-grayscale: 0;
  --image-opacity: 100%;
  }
  
  &.dark {
  /* --neutral: #030712; */
  --neutral: #000000;
/* Slate (Value-Swapped for Dark Mode) */
--slate-50: #020617;
--slate-100: #0f172a;
--slate-200: #1e293b;
--slate-300: #334155;
--slate-400: #475569;
--slate-500: #64748b;
--slate-600: #94a3b8;
--slate-700: #cbd5e1;
--slate-800: #e2e8f0;
--slate-900: #f1f5f9;
--slate-950: #f8fafc;

/* Gray (Value-Swapped for Dark Mode) */
--gray-50: #030712;
--gray-100: #111827;
--gray-200: #1f2937;
--gray-300: #374151;
--gray-400: #4b5563;
--gray-500: #6b7280;
--gray-600: #9ca3af;
--gray-700: #d1d5db;
--gray-800: #e5e7eb;
--gray-900: #f3f4f6;
--gray-950: #f9fafb;

/* Zinc (Value-Swapped for Dark Mode) */
--zinc-50: #09090b;
--zinc-100: #18181b;
--zinc-200: #27272a;
--zinc-300: #3f3f46;
--zinc-400: #52525b;
--zinc-500: #71717a;
--zinc-600: #a1a1aa;
--zinc-700: #d4d4d8;
--zinc-800: #e4e4e7;
--zinc-900: #f4f4f5;
--zinc-950: #fafafa;

/* Neutral (Value-Swapped for Dark Mode) */
--neutral-50: #0a0a0a;
--neutral-100: #171717;
--neutral-200: #262626;
--neutral-300: #404040;
--neutral-400: #525252;
--neutral-500: #737373;
--neutral-600: #a3a3a3;
--neutral-700: #d4d4d4;
--neutral-800: #e5e5e5;
--neutral-900: #f5f5f5;
--neutral-950: #fafafa;

/* Stone (Value-Swapped for Dark Mode) */
--stone-50: #0c0a09;
--stone-100: #1c1917;
--stone-200: #292524;
--stone-300: #44403c;
--stone-400: #57534e;
--stone-500: #78716c;
--stone-600: #a8a29e;
--stone-700: #d6d3d1;
--stone-800: #e7e5e4;
--stone-900: #f5f5f4;
--stone-950: #fafaf9;

/* Red (Value-Swapped for Dark Mode) */
--red-50: #450a0a;
--red-100: #7f1d1d;
--red-200: #991b1b;
--red-300: #b91c1c;
--red-400: #dc2626;
--red-500: #ef4444;
--red-600: #f87171;
--red-700: #fca5a5;
--red-800: #fecaca;
--red-900: #fee2e2;
--red-950: #fef2f2;

/* Orange (Value-Swapped for Dark Mode) */
--orange-50: #431407;
--orange-100: #7c2d12;
--orange-200: #9a3412;
--orange-300: #c2410c;
--orange-400: #ea580c;
--orange-500: #f97316;
--orange-600: #fb923c;
--orange-700: #fdba74;
--orange-800: #fed7aa;
--orange-900: #ffedd5;
--orange-950: #fff7ed;

/* Amber (Value-Swapped for Dark Mode) */
--amber-50: #451a03;
--amber-100: #78350f;
--amber-200: #92400e;
--amber-300: #b45309;
--amber-400: #d97706;
--amber-500: #f59e0b;
--amber-600: #fbbf24;
--amber-700: #fcd34d;
--amber-800: #fde68a;
--amber-900: #fef3c7;
--amber-950: #fffbeb;

/* Yellow (Value-Swapped for Dark Mode) */
--yellow-50: #422006;
--yellow-100: #713f12;
--yellow-200: #854d0e;
--yellow-300: #a16207;
--yellow-400: #ca8a04;
--yellow-500: #eab308;
--yellow-600: #facc15;
--yellow-700: #fde047;
--yellow-800: #fef08a;
--yellow-900: #fef9c3;
--yellow-950: #fefce8;

/* Lime (Value-Swapped for Dark Mode) */
--lime-50: #1a2e05;
--lime-100: #365314;
--lime-200: #3f6212;
--lime-300: #4d7c0f;
--lime-400: #65a30d;
--lime-500: #84cc16;
--lime-600: #a3e635;
--lime-700: #bef264;
--lime-800: #d9f99d;
--lime-900: #ecfccb;
--lime-950: #f7fee7;

/* Green (Value-Swapped for Dark Mode) */
--green-50: #052e16;
--green-100: #14532d;
--green-200: #166534;
--green-300: #15803d;
--green-400: #16a34a;
--green-500: #22c55e;
--green-600: #4ade80;
--green-700: #86efac;
--green-800: #bbf7d0;
--green-900: #dcfce7;
--green-950: #f0fdf4;

/* Emerald (Value-Swapped for Dark Mode

) */
--emerald-50: #022c22;
--emerald-100: #064e3b;
--emerald-200: #065f46;
--emerald-300: #047857;
--emerald-400: #059669;
--emerald-500: #10b981;
--emerald-600: #34d399;
--emerald-700: #6ee7b7;
--emerald-800: #a7f3d0;
--emerald-900: #d1fae5;
--emerald-950: #ecfdf5;

/* Teal (Value-Swapped for Dark Mode) */
--teal-50: #042f2e;
--teal-100: #134e4a;
--teal-200: #115e59;
--teal-300: #0f766e;
--teal-400: #0d9488;
--teal-500: #14b8a6;
--teal-600: #2dd4bf;
--teal-700: #5eead4;
--teal-800: #99f6e4;
--teal-900: #ccfbf1;
--teal-950: #f0fdfa;

/* Cyan (Value-Swapped for Dark Mode) */
--cyan-50: #083344;
--cyan-100: #164e63;
--cyan-200: #155e75;
--cyan-300: #0e7490;
--cyan-400: #0891b2;
--cyan-500: #06b6d4;
--cyan-600: #22d3ee;
--cyan-700: #67e8f9;
--cyan-800: #a5f3fc;
--cyan-900: #cffafe;
--cyan-950: #ecfeff;

/* Sky (Value-Swapped for Dark Mode) */
--sky-50: #082f49;
--sky-100: #0c4a6e;
--sky-200: #075985;
--sky-300: #0369a1;
--sky-400: #0284c7;
--sky-500: #0ea5e9;
--sky-600: #38bdf8;
--sky-700: #7dd3fc;
--sky-800: #bae6fd;
--sky-900: #e0f2fe;
--sky-950: #f0f9ff;

/* Blue (Value-Swapped for Dark Mode) */
--blue-50: #172554;
--blue-100: #1e3a8a;
--blue-200: #1e40af;
--blue-300: #1d4ed8;
--blue-400: #2563eb;
--blue-500: #3b82f6;
--blue-600: #60a5fa;
--blue-700: #93c5fd;
--blue-800: #bfdbfe;
--blue-900: #dbeafe;
--blue-950: #eff6ff;

/* Indigo (Value-Swapped for Dark Mode) */
--indigo-50: #1e1b4b;
--indigo-100: #312e81;
--indigo-200: #3730a3;
--indigo-300: #4338ca;
--indigo-400: #4f46e5;
--indigo-500: #6366f1;
--indigo-600: #818cf8;
--indigo-700: #a5b4fc;
--indigo-800: #c7d2fe;
--indigo-900: #e0e7ff;
--indigo-950: #eef2ff;

/* Violet (Value-Swapped for Dark Mode) */
--violet-50: #2e1065;
--violet-100: #4c1d95;
--violet-200: #5b21b6;
--violet-300: #6d28d9;
--violet-400: #7c3aed;
--violet-500: #8b5cf6;
--violet-600: #a78bfa;
--violet-700: #c4b5fd;
--violet-800: #ddd6fe;
--violet-900: #ede9fe;
--violet-950: #f5f3ff;

/* Purple (Value-Swapped for Dark Mode) */
--purple-50: #3b0764;
--purple-100: #581c87;
--purple-200: #6b21a8;
--purple-300: #7e22ce;
--purple-400: #9333ea;
--purple-500: #a855f7;
--purple-600: #c084fc;
--purple-700: #d8b4fe;
--purple-800: #e9d5ff;
--purple-900: #f3e8ff;
--purple-950: #faf5ff;

/* Fuchsia (Value-Swapped for Dark Mode) */
--fuchsia-50: #4a044e;
--fuchsia-100: #701a75;
--fuchsia-200: #86198f;
--fuchsia-300: #a21caf;
--fuchsia-400: #c026d3;
--fuchsia-500: #d946ef;
--fuchsia-600: #e879f9;
--fuchsia-700: #f0abfc;
--fuchsia-800: #f5d0fe;
--fuchsia-900: #fae8ff;
--fuchsia-950: #fdf4ff;

--backdrop-color: rgba(0, 0, 0, 0.3);

--shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.4);
--shadow-md: 0px 0.6rem 2.4rem rgba(0, 0, 0, 0.3);
--shadow-lg: 0 2.4rem 3.2rem rgba(0, 0, 0, 0.4);

--image-grayscale: 10%;
--image-opacity: 90%;
  }
  /* sky */
  /* --brand-50:  #f0f9ff;
  --brand-100: #dbeafe;
  --brand-200:#bfdbfe;
  --brand-300: #93c5fd;
  --brand-400: #38bdf8;
  --brand-500: #0ea5e9;
  --brand-600: #0284c7;
  --brand-700: #0369a1;
  --brand-800: #075985;
  --brand-900: #082f49; */

  --brand-50: #f0f9ff;
  --brand-100: #e0f2fe;
  --brand-200: #bae6fd;
  --brand-300: #7dd3fc;
  --brand-400: #38bdf8;
  --brand-500: #0ea5e9;
  --brand-600: #0284c7;
  --brand-700: #0369a1;
  --brand-800: #075985;
  --brand-900: #0c4a6e;
  --brand-950: #082f49;

  /* Tory blue*/
  /* --brand-50:  #edf9ff;
  --brand-100: #d6f1ff;
  --brand-200: #b6e7ff;
  --brand-300: #85dbff;
  --brand-400: #4bc4ff;
  --brand-500: #22a5ff;
  --brand-600: #0a86ff;
  --brand-700: #046ef1;
  --brand-800: #0a55bd;
  --brand-900: #0f4c99;
  --brand-950: #0f2f5c; */
  
  /* Indigo */
  /* --brand-50: #eef2ff;
  --brand-100: #e0e7ff;
  --brand-200: #c7d2fe;
  --brand-500: #6366f1;
  --brand-600: #4f46e5;
  --brand-700: #4338ca;
  --brand-800: #3730a3;
  --brand-900: #312e81; */
  
  --border-radius-tiny: 3px;
  --border-radius-sm: 5px;
  --border-radius-md: 7px;
  --border-radius-lg: 9px;
  --border-radius-xlg: 13px;
  --border-radius-xxlg: 18px;


}

*,
*::before,
*::after {
  box-sizing: border-box;
  padding: 0;
  margin: 0;

  /* Creating animations for dark mode */
  transition: background-color 0.3s, border 0.3s;
}

/* font-family: "Poppins", sans-serif; */
/* color: var(--zinc-700); */
body {
  transition: color 0.3s, background-color 0.3s;
  /* overflow: hidden; */
  min-height: 100vh;

}

input,
button,
textarea,
select {
  font: inherit;
  color: inherit;
}

button {
  cursor: pointer;
}

*:disabled {
  cursor: not-allowed;
}

select:disabled,
input:disabled {
  background-color: var(--zinc-200);
  color: var(--zinc-500);
}

input:focus,
textarea:focus,
select:focus {
  outline: 1px solid var(--brand-600);
  outline-offset: -1px;
}

a {
  color: inherit;
  text-decoration: none;
}

ul {
  list-style: none;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
  hyphens: auto;
}

img {
  max-width: 100%;

  /* For dark mode */
  filter: grayscale(var(--image-grayscale)) opacity(var(--image-opacity));
}
.business-form-container {
  max-width: 400px;
  margin: auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

form {
  display: flex;
  flex-direction: column;
}

label {
  margin-bottom: 8px;
}

textarea,
input {
  padding: 8px;
  margin-bottom: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

`;

export default GlobalStyles;
